import Maths3 from "oc-threejs/Maths3";
import BaseType from "./BaseType";
import Scenes from "oc-threejs/Scenes";
import BoxRuler from "./BoxRuler";
import { v3 } from "oc-threejs/short3";
import { FormControlUnstyledContext } from "@mui/material";

export default class ArrangementRuler extends BaseType(THREE.Group) {

    rulers = [];
    hideForSAOPASS = true;

    constructor(vsData) {
        super(vsData);
        // TODO: SETTINGS!
        this.visible = true;
        this.showElementRuler = [];
        this.interieurDragRuler = [];
        this.fontSizes = {
            outer: APP.settings.getInt('drag_drop_ux_fontsize_outer', 12),
            inner: APP.settings.getInt('drag_drop_ux_fontsize_inner', 4),
            elements: APP.settings.getInt('drag_drop_ux_fontsize_elements', 10),
        };
    }

    vsUpdate(forced = false, hover = false) {

        if (forced || this.isVsChanged('size', a => a.schraenke.map(s => ({
            box: s.box,
            position: s.position,
            quaternion: s.quaternion,
            sizeTop: s.sizeTop
        }))) || this.isVsChanged('elements', a => a.schraenke.map(s => ({
            elements: s.elements.length,
        })))) {
            // const schraenke = []; //APP.arrangement.schraenke;
            // if (schraenke.length==0) {

            //     this.setRulerCount(0);

            // } else if (schraenke.length==1) {

            //     this.setRulerCount(1);

            //     const ruler = this.rulers[0];
            //     const desc = ruler.description;
            //     desc.xbottom.show = true;
            //     desc.xbottom.rulerOffset.z = 40;
            //     desc.yright.show = true;
            //     desc.yright.rulerOffset.x = 20;
            //     desc.zbottom.show = true;
            //     desc.zbottom.rulerOffset.x = 20;
            //     ruler.updateBox(schraenke[0].getBox3World());

            // } else {

            //     this.setRulerCount(schraenke.length+1);

            //     const ruler = this.rulers[0];
            //     const desc = ruler.description;
            //     desc.xtop.show = true;
            //     desc.yleft.show = true;
            //     desc.yright.show = true;
            //     desc.ztop.show = true;

            //     const unionBox = new THREE.Box3();
            //     schraenke.forEach(s => s.getBox3World(unionBox));
            //     ruler.updateBox(unionBox);

            //     schraenke.forEach((schrank,i)=>{
            //         const ruler = this.rulers[i+1];
            //         const desc = ruler.description;
            //         if (Math.abs(schrank.drehungAbsolut)<10) {
            //             desc.zbottom.show = true;
            //             desc.xbottom.show = false;
            //         } else {
            //             desc.zbottom.show = false;
            //             desc.xbottom.show = true;
            //             desc.xbottom.textQuaternion = Maths3.quaternion.y90;
            //         }
            //         ruler.updateBox(schrank.getBox3World());
            //     });

            // }


            this.updateRulerStyle(forced, hover);

        }

    }

    removeRuler() {
        this.dragDir = null;
        this.interieurDragRuler = [];
        this.vsUpdate(true);
    }

    countNeededRulers(forced = false, hover=false) {
        let result = 0;
        const schraenke = APP.arrangement.schraenke;
        if (APP.arrangement.maße) {
            result += schraenke.length;
            schraenke.forEach((schrank) => {
                if (this.showSizeTopRuler && (schrank.angleSide === 'left' || schrank.angleSide === 'right') && schrank.object3d.visible) {
                    result += 1;
                }
            });
        }

        if (hover || APP.arrangement.maße) {
            if (APP.settings.getBool('drag_drop_ux_ruler_show', true)) {
                schraenke.forEach((schrankValue, schrankIndex) => {

                    if (schrankValue.elements.length > 0) {
                        schrankValue.elements.forEach(ele => {
                            result += ele.getDoors().length
                        })
                    }
                });
            }
        }
        return result;
    }

    forceRepaint() {
        this.setRulerCount(0);
        this.updateRulerStyle(true);
    }

    resetRulerDescriptions(ruler) {
        const sides = ['xtop', 'xbottom', 'yleft', 'yright', 'yleftfront', 'ztop', 'zbottom'];
        sides.forEach((side) => {
            ruler.description[side].show = false;
            ruler.description[side].fontHeight = this.fontSizes.outer;
        });
        ruler.isInterieurRuler = false;
        ruler.isElementRuler = false;
        return ruler;
    }

    setRulerCount(count) {
        if (this.rulers.length !== count) {
            this.rulers.forEach(r => Scenes.remove(r));
            this.rulers = _.range(0, count).map(() => {
                const ruler = new BoxRuler();
                this.add(ruler);
                return ruler;
            });

            this.rulers.forEach((ruler) => {
                for (const prop in ruler.description) {
                    if (!ruler.description.hasOwnProperty(prop)) continue;
                    if (ruler.description[prop] !== null) {
                        ruler.description[prop].fontHeight = this.fontSizes.outer;
                    }
                }
            });
        }
    }

    updateRulerStyle(forced = false, hover=false) {

        const rulerCount = this.countNeededRulers(forced, hover);
        const schraenke = [];
        const data = APP.arrangement.schraenke;
        const isEckschrank = APP.arrangement.isEckschrank;
        const elementRulerOffsetXZ = APP.settings.getInt('element_ruler_offset_xz', 12);
        const elementRulerOffsetXY = APP.settings.getInt('element_ruler_offset_xy', -3);
        let rulerIndex = 0;

        this.setRulerCount(rulerCount, forced);
        data.forEach(s => {
            if (s.object3d.visible || forced) schraenke.push(s);
        });

        if (schraenke.some(s => !s.box) || schraenke.length < 1 || rulerCount < 1) {
            return;
        }
        if (hover || APP.arrangement.maße) {

            schraenke.forEach((schrankValue, schrankIndex) => {

                if (schrankValue.elements.length > 0) {
                    schrankValue.elements.forEach((ele, i) => {
                        ele.getDoors().forEach((door, index) => {
                            const ruler = this.resetRulerDescriptions(this.rulers[rulerIndex]);

                            ruler.description.yright.fontHeight = this.fontSizes.elements;
                            ruler.description.yright.gridPoints = [v3(0.5, 0, 1), v3(0.5, 1, 1)];
                            ruler.description.yright.rulerOffset = v3(0, 0, 8);
                            ruler.description.yright.textOffset = v3(0, 0, 0);
                            ruler.description.yright.show = true
                            ruler.description.xbottom.show = false;
                            ruler.isElementRuler = true;
                            ruler.isInterieurRuler = true;
                            const box = door.frontBox.clone();
                            const frontCenter = door.frontBox.getCenter();
                            const afineFrontCenter = door.localToSchrank(frontCenter);
                            const deltaY = afineFrontCenter.y - frontCenter.y ;
                            box.min.y+=deltaY;
                            box.max.y+=deltaY;
                            ruler.updateBox(door.getBox3World(box));
                            ruler.visible = true;
                            rulerIndex++
                           
                        })
                    })

                }

            });
        }
        if (APP.arrangement.maße) {

            schraenke.forEach((schrankValue, schrankIndex) => {
                const ruler = this.resetRulerDescriptions(this.rulers[rulerIndex]);
                const schrankBox = schrankValue.getBox3World();
                const isLeft = schrankValue.angleSide === 'left';
                const isRight = schrankValue.angleSide === 'right';
                const rulerBox = schrankBox.clone();
                const drehung = schrankValue.drehungAbsolut;

                if (isEckschrank) {
                    ruler.description.zbottom.show = drehung === 0;
                    ruler.description.xbottom.show = drehung !== 0;
                    ruler.description.xbottom.textQuaternion = Maths3.quaternion.y90;
                } else {
                    ruler.description.xbottom.show = true;
                    ruler.description.yright.show = true;
                    ruler.description.zbottom.show = true;
                }
                if (this.showSizeTopRuler && (isLeft || isRight)) {
                    rulerBox.min.y = schrankValue.box.min.y;
                    rulerBox.max.y = schrankValue.sizeTop.y;
                    ruler.description.yleftback.show = isLeft;
                    ruler.description.yright.show = isRight;
                    ruler.description.xbottom.show = true;
                    ruler.description.zbottom.show = true;
                }
                ruler.updateBox(rulerBox);
                rulerIndex++;

                if (this.showSizeTopRuler && (isLeft || isRight)) {
                    const ruler = this.resetRulerDescriptions(this.rulers[rulerIndex]);
                    const rulerBox = schrankBox.clone();
                    if (isLeft) {
                        rulerBox.min.x = (schrankBox.max.x - schrankValue.sizeTop.x) + schraenke.length-1;
                    } else {
                        rulerBox.max.x = (schrankBox.min.x + schrankValue.sizeTop.x) + schraenke.length-1;
                    }
                    ruler.description.xtop.show = true;
                    ruler.description.yleftback.show = isRight;
                    ruler.description.yright.show = isLeft;
                    ruler.updateBox(rulerBox);
                    rulerIndex++;
                }
            });

        }




    }

}
